type HeapProperties = Record<string, string | number | boolean | null | undefined>

declare global {
  interface Window {
    heap: {
      track: (event: string, properties?: HeapProperties) => void
      identify: (identity: string) => void
      resetIdentity: () => void
      addUserProperties: (properties: HeapProperties) => void
      addEventProperties: (properties: HeapProperties) => void
      removeEventProperty: (property: string) => void
      clearEventProperties: () => void
      appid: string
      userEmail: string
      identity: string | null
      config: unknown
    }
  }
}

export function identifyUser(userEmail: string) {
  window.heap.identify(userEmail)
}

export function addUserProperties(properties: HeapProperties) {
  window.heap.addUserProperties(properties)
}

export function trackEvent(event: string, properties?: HeapProperties) {
  window.heap.track(event, properties)
}
